const de = {
  title: 'Benachrichtigungseinstellungen für das System',
  systemNotifications: 'Systembenachrichtigung',
  headline: 'Überschrift',
  content: 'Inhalt',
  startDate: 'Startdatum',
  endDate: 'Enddatum',
  isActive: 'Aktiv',
  type: 'Typ',
  timePeriod: 'Zeitraum',
  notification: 'Mitteilung',
  newSystemNotification: 'Neue Systembenachrichtigung',
  editSystemNotification: 'Systembenachrichtigung Bearbeitung',
  gotIt: 'Verstanden',
  alerts: {
    error: {
      loadSystemNotifications: 'Systembenachrichtigungen konnten nicht geladen werden.',
      updateSystemNotification: 'Systembenachrichtigung konnte nicht bearbeitet werden.',
      createSystemNotification: 'Systembenachrichtigung konnte nicht erstellt werden.',
      deleteSystemNotification: 'Systembenachrichtigung konnte nicht gelöscht werden.'
    },
    success: {
      updateSystemNotification: 'Systembenachrichtigung wurde erfolgreich bearbeitet.',
      createSystemNotification: 'Systembenachrichtigung wurde erfolgreich erstellt.',
      deleteSystemNotification: 'Systembenachrichtigung wurde erfolgreich gelöscht.'
    }
  },
  deleteConfirm: {
    title: 'Wirklich löschen?',
    message: 'Wollen Sie wirklich diese Systembenachrichtigung löschen?'
  }
};

export default de;
export type SystemNotificationSettingsTranslation = typeof de;
